export default __webpack_public_path__ + "static/media/burlap.2b1bcdd9.png";